<template>
  <div class="paging-loader">
    <div class="stage">
      <div class="dot-pulse"></div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
});
</script>

<style scoped lang='scss'>
.paging-loader {
  display: block;
  position: absolute;
  bottom: 0px;
  width: 100%;
  height: 45px;
  background: rgb(255,255,255);
}
.stage {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 2rem 0;
  margin: 0 -5%;
  overflow: hidden;
}
/**
 * ==============================================
 * Dot Pulse
 * ==============================================
 */
.dot-pulse {
  position: relative;
  left: -9999px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #1c519c;
  color: #1c519c;
  box-shadow: 9999px 0 0 -5px #1c519c;
  animation: dotPulse 1.5s infinite linear;
  animation-delay: .25s;
}

.dot-pulse::before, .dot-pulse::after {
  content: '';
  display: inline-block;
  position: absolute;
  top: 0;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #1c519c;
  color: #1c519c;
}

.dot-pulse::before {
  box-shadow: 9984px 0 0 -5px #1c519c;
  animation: dotPulseBefore 1.5s infinite linear;
  animation-delay: 0s;
}

.dot-pulse::after {
  box-shadow: 10014px 0 0 -5px #1c519c;
  animation: dotPulseAfter 1.5s infinite linear;
  animation-delay: .5s;
}

@keyframes dotPulseBefore {
  0% {
    box-shadow: 9984px 0 0 -5px #1c519c;
  }
  30% {
    box-shadow: 9984px 0 0 2px #1c519c;
  }
  60%,
  100% {
    box-shadow: 9984px 0 0 -5px #1c519c;
  }
}

@keyframes dotPulse {
  0% {
    box-shadow: 9999px 0 0 -5px #1c519c;
  }
  30% {
    box-shadow: 9999px 0 0 2px #1c519c;
  }
  60%,
  100% {
    box-shadow: 9999px 0 0 -5px #1c519c;
  }
}

@keyframes dotPulseAfter {
  0% {
    box-shadow: 10014px 0 0 -5px #1c519c;
  }
  30% {
    box-shadow: 10014px 0 0 2px #1c519c;
  }
  60%,
  100% {
    box-shadow: 10014px 0 0 -5px #1c519c;
  }
}
</style>
